import React from 'react'
import { IconButton, Stack } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'
import { useNavigate } from 'react-router-dom'
import { ITableColumn, TableColumnType, TableList } from 'src/components/table'
import { rutaPorCodSistema } from 'src/pages/sistema/RefactorLayout'
import { SistemaTipo } from 'src/types/enum/enum'
import { numberFormatter } from 'src/utils/formatters/numberFormatter'
import { OperacionLCTCLimiteAprobado } from '../../sistema/sistemas/lctc/types/dto'
import { OperacionLCTCLimiteAprobadoFields } from '../../sistema/sistemas/lctc/types/fields'

interface LimitesLCTCTablaProps {
    limites: OperacionLCTCLimiteAprobado[]
    loading?: boolean
    error?: boolean
}

function LimitesLCTCTabla({ limites, loading, error }: LimitesLCTCTablaProps) {
    const navigate = useNavigate()

    const columns: ITableColumn[] = [
        { label: 'Tipo Cliente', value: OperacionLCTCLimiteAprobadoFields.DescClienteTipo },
        { label: 'Sub-Tipo Cliente', value: OperacionLCTCLimiteAprobadoFields.DescClienteSubTipo },
        { label: 'Fecha Aprobación', value: OperacionLCTCLimiteAprobadoFields.FechaAprobacion, type: TableColumnType.Date },
        {
            label: 'Concertación',
            onRenderCell: (row: OperacionLCTCLimiteAprobado) => (
                <span>{row[OperacionLCTCLimiteAprobadoFields.LimiteConcertacionFinal]}</span>
            )
        },
        {
            label: 'DVP',
            onRenderCell: (row: OperacionLCTCLimiteAprobado) => (
                <span>{row[OperacionLCTCLimiteAprobadoFields.LimiteLiquidacionDVPFinal]}</span>
            )
        },
        {
            label: 'FOP',
            onRenderCell: (row: OperacionLCTCLimiteAprobado) => (
                <span>{row[OperacionLCTCLimiteAprobadoFields.LimiteLiquidacionFOPFinal]}</span>
            )
        },
        {
            label: 'Operación',
            onRenderCell: (row: OperacionLCTCLimiteAprobado) => (
                <Stack direction={'row'} alignItems={'center'}>
                    <span># {row[OperacionLCTCLimiteAprobadoFields.IdMensaje]}</span>
                    <IconButton onClick={() => navigate(`/operacion/${rutaPorCodSistema[SistemaTipo.LCTC]}/${row[OperacionLCTCLimiteAprobadoFields.IdMensaje]}`)}>
                        <LaunchIcon />
                    </IconButton>
                </Stack>
            )
        }
    ]

    return <TableList entityList={limites} columns={columns} isLoading={!!loading} error={error} />
}

export default LimitesLCTCTabla
